import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/store'

Vue.config.productionTip = false

//引入element-ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

//引入图片截图
import VueCropper from 'vue-cropper'
Vue.use(VueCropper)

//引入swiper
import 'swiper/dist/css/swiper.css';

//引入css文件
import '@/assets/css/common.css'

export default new Vue({
	el:'#app',
	router,
	store,
	render: h => h(App)
})
